import * as React from 'react';

const FlagMarker = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={86} height={87} viewBox="0 0 86 87" {...props}>
        <defs>
            <filter
                id="flagmarker_a"
                width="239.6%"
                height="239.6%"
                x="-69.8%"
                y="-49%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={9.5} />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0.0472862279 0 0 0 0 0.231790044 0 0 0 0 0.485252491 0 0 0 0.1 0"
                />
            </filter>
            <circle id="flagmarker_b" cx={24} cy={24} r={24} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(19 9.113)">
                <use xlinkHref="#flagmarker_b" fill="currentColor" filter="url(#flagmarker_a)" />
                <use xlinkHref="#flagmarker_b" fill="#FFF" />
            </g>
            <g fill="currentColor" fillRule="nonzero">
                <path d="M50.588 26.563a1.06 1.06 0 0 0-1.077-.067 8.1 8.1 0 0 1-2.751.59 12.4 12.4 0 0 1-3.16-.653c-2.238-.653-3.013-.808-4.73-.586a1 1 0 0 0-.87.993v10.013a1 1 0 0 0 1.115.994c1.503-.173 2.203-.026 4.294.586 1.082.374 2.209.603 3.35.68a9.4 9.4 0 0 0 3.388-.768c.448-.17.853-.4.853-1.018V27.38a1 1 0 0 0-.412-.817M36 25.113a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0v-14a1 1 0 0 0-1-1" />
            </g>
        </g>
    </svg>
);
export default FlagMarker;
